import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { PendingAppointmentComponent } from './pending-appointment.component';


const routes: Routes = [
  {
    path: '',
    component: PendingAppointmentComponent,
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PendingAppointmentRoutingModule { }
